(ns dashboard.components.footer
  (:require
   [dashboard.utils :refer [listen]]
   [dashboard.subs :as subs]
   [dashboard.config :as config]
   ["date-fns" :refer [format]]))

(defn footer []
  [:footer.pb-4.text-xs
   [:p.flex.justify-center.text-gray-500
    (str (listen ::subs/product-name) " " config/version)]
   [:p.flex.justify-center.text-gray-300
    "© 2023 Tachikoma AI, Inc."]])
